import HCaptcha from '@hcaptcha/react-hcaptcha'
// External Imports
import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  CAPTCHA_ERRORS,
  MAX_RETRY_COUNT,
  NO_CAPTCHA_REQUIRED_STATUS,
} from 'src/dataLayer/localData/captcha.js'
import { reportCaptchaError } from 'src/dataLayer/remoteData/rollbar/index.js'
// Internal Imports
import { useCaptchaConfigContext } from 'src/viewLayer/components/contexts/CaptchaConfigContext.js'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext.js'

// Component Definition
function CaptchaMagicLink({ setCaptchaToken, shouldExecuteCaptcha }) {
  const { locale } = useRouteParamsContext()
  const {
    captchaConfig: { siteKey },
  } = useCaptchaConfigContext()
  const captchaReference = useRef(null)
  const [retryCount, setRetryCount] = useState(0)
  const isConfigAvailable = Boolean(siteKey && siteKey !== NO_CAPTCHA_REQUIRED_STATUS)

  const executeCaptcha = useCallback(() => {
    if (captchaReference.current) {
      captchaReference.current.resetCaptcha()
      captchaReference.current.execute('captcha-magic-link')
    }
  }, [captchaReference.current])

  useEffect(() => {
    if (shouldExecuteCaptcha) {
      executeCaptcha()
    }
  }, [executeCaptcha, shouldExecuteCaptcha])

  useEffect(() => {
    if (siteKey === NO_CAPTCHA_REQUIRED_STATUS) {
      setCaptchaToken(NO_CAPTCHA_REQUIRED_STATUS)
    }
  }, [siteKey, setCaptchaToken])

  const onVerifyCaptcha = (token) => {
    if (token) {
      setCaptchaToken(token)
    }
  }

  const onErrorCaptcha = (error) => {
    if (CAPTCHA_ERRORS.has(error) && retryCount < MAX_RETRY_COUNT) {
      setRetryCount((previousRetryCount) => previousRetryCount + 1)
      executeCaptcha()
      reportCaptchaError(
        `Error while verifying captcha. Number of retry attempts: ${retryCount + 1}`,
        new Error(error),
      )
    } else {
      reportCaptchaError('Error while retry verifying captcha:', new Error(error))
    }
  }

  const onExpireCaptcha = () => {
    setCaptchaToken('')
    executeCaptcha()
  }

  if (!isConfigAvailable) {
    return null
  }

  return (
    <HCaptcha
      id="captcha-magic-link"
      languageOverride={locale === 'en_GB' ? 'en' : locale}
      onChalExpired={onExpireCaptcha}
      onError={onErrorCaptcha}
      onExpire={onExpireCaptcha}
      onVerify={onVerifyCaptcha}
      ref={captchaReference}
      sitekey={siteKey}
      size="invisible"
    />
  )
}

export { CaptchaMagicLink }
